<template>
	<div class="switch_con pt-22 plr-16" :class="{'pb-30': padShow }">
    <ul class="switch_con_inner">
      <li class="list_every pd-16 flex mb-16 swifth_every" v-for="(item, index) in list"  :key="index" @click="switchPlan(item.id, item.plan_status)">
				<img class="switch_img com_hea_img" :src="item.book_cover" alt="">

				<div class="ml-16 pt-4 flex1">
					<div class="flexs flex-jus">
						<div class="fz-14 fw-500 c1 w154 text-hide l-h-14">{{item.book_name}}</div>
						<div class="fz-12 fw-500 c0" v-if="item.plan_status">当前在学</div>
						<div class="fz-12 c2 flexs" v-else @click.stop="delPlan(item.id,item.current_progress )"> <span class="iconfont icon-shanchu"></span> <span class="ml-4">删除</span> </div>
					</div>

					<div class="l-h-12 fz-12 c3 mtb-12-10 l-h-12 fz-12 c3">每日{{item.day_study_plan}}词，剩余{{item.time_remaining}}天</div>
					<div class="mb-8 l-h-12 fz-12 c3">学习进度：{{item.current_progress}}/{{item.word_base}}</div>
					<div><van-progress color="#497CFF" :percentage="item.current_progress / item.word_base * 100 " :show-pivot="false"/></div>
				</div>
			</li>
		</ul>

		<div class="btn_contain">
      <div class="blue_btn" @click="$router.replace('/addplan')">
        添加计划
      </div>
    </div>
    <noData v-if="show"></noData>
  	<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>
	import { getEnglishBookPlanList, changeEnglishBookPlan, delEnglishBookPlan } from '@/api/api.js'
	import {getShowPadding} from "@/utils/common.js";
	import noData from "@/components/noData"
	import loading from "@/components/loading"
	export default {
		components: {
			noData,
			loading
		},
		data() {
			return {
			  list: [],
				padShow: false,
				show: false,
				loadFlag: false
			};
		},
		created() {
			this.initData()
		},
		mounted(){
			this.$nextTick(()=>{
        this.padShow = getShowPadding()
			})
		},
		methods: {
			async initData(){
				this.loadFlag = true
        const res = await getEnglishBookPlanList({ })
				this.loadFlag = false
				if(res.code === 1000){
          this.list = res.data
					if(this.list.length == 0){
            this.show = true
					}
				}
			},
      
			// 删除计划
			delPlan(plan_id, current_progress){
        this.$dialog.confirm({
					title: '删除计划',
					message: `你已经学习了该计划的${current_progress}个单词，删除后将无法撤销，确定删除计划？`,
				})
					.then(async () => {
						const res = await delEnglishBookPlan({ plan_id })
						this.initData()
					})
					.catch(() => {
						// on cancel
					});
			},
			switchPlan(id, status){
				if(status == 1){
          return this.$toast('书籍正在学习，无需切换')
				}
				this.$dialog.confirm({
					title: '切换计划',
					message: '确认切换计划吗？',
				})
					.then(async () => {
						const res = await changeEnglishBookPlan({ plan_id: id })
						if(res.code == 1000){
              this.$router.replace('/wordbook')
						}else {
							this.$toast(res.msg)
						}
					})
					.catch(() => {
						// on cancel
					});
        
			}
    }
	};
</script>
<style lang="less" scoped>
.swifth_every:last-child {
	margin-bottom: 0;
}

.pp {
	padding-bottom: 30px;
}

</style>
